<template>
  <div class="hzc-two-page-header">
    当前位置：<span @click="back" class="back">焦炭</span> > {{ typeTitle }}
  </div>
</template>

<script>
export default {
  name: "twoPageHeader",
  data() {
    return{
    }
  },
  props:[
    'typeTitle'
  ],
  methods: {
    /**
     * 回退
     */
    back() {
      this.$router.push('/coke')
    },
  }
}
</script>

<style scoped>
.back {
  cursor: pointer;
}
</style>
